<template>
  <cos-modal
    v-model:visible="visible"
    :title="editForm.id ? '编辑' : '新增'"
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="countryCharCode" label="国家中文名" :rules="[{ required: true, message: '请选择' }]">
        <CosApiSelect
          :api="getCountry"
          :allowClear="false"
          show-search
          optionFilterProp="label"
          v-model:value="editForm.countryCharCode"
          :fieldNames="{ label: 'countryCnName', value: 'countryCharCode' }"
        ></CosApiSelect>
      </a-form-item>
      <a-form-item name="provinceName" label="省 / 州:" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model:value="editForm.provinceName" placeholder="请输入" v-trim/>
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref } from 'vue'
import { adminAreaSave, adminAreaUpdate, adminAreaListByParentId } from '@/api/gucangSales/administrativeRegion'
import type { FormInstance } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import { adminAreaSaveParams } from '@/typings/api/gucangSale'

export default { name: 'editModalProvince' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<adminAreaSaveParams>({})
const emit = defineEmits(['success'])
const toggle = (row?: adminAreaSaveParams) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
    console.log('editForm.value: ', editForm.value)
  } else {
    editForm.value = {}
  }
}
const conuntryArr = ref<adminAreaSaveParams[]>([])
const getCountry = async () => {
  try {
    const res:any = await adminAreaListByParentId({ parentId: '-1', level: 1 })
    conuntryArr.value = res.data
    return res.data
  } catch (error) {
    console.log('getCountry error: ', error)
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const p = editForm.value
    const index = conuntryArr.value.findIndex((item:adminAreaSaveParams) => item.countryCharCode === editForm.value.countryCharCode)

    try {
      if (editForm.value.id) {
        await adminAreaUpdate({
          ...p,
          id: editForm.value.id,
          level: 2,
          name: editForm.value.provinceName,
          fullName: `${conuntryArr.value[index].countryCnName}/${editForm.value.provinceName}`
        })
      } else {
        await adminAreaSave({
          ...p,
          level: 2,
          name: editForm.value.provinceName,
          fullName: `${conuntryArr.value[index].countryCnName}/${editForm.value.provinceName}`,
          countryCnName: conuntryArr.value[index].countryCnName,
          countryEnName: conuntryArr.value[index].countryEnName,
          parentId: conuntryArr.value[index].id
        })
      }
      toggle()
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      message.success(editForm.value?.id ? '编辑成功' : '新增成功')
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss"></style>
